import React, { Component } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import style from "./InvoiceList.module.css";
import { fetchInvoiceList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import  PatientInvoiceCash  from "./PatientInvoiceCash";
import  InventoryInvoice from "./InventoryInvoice";
import  PatientInvoiceMediclaim  from "./PatientInvoiceMediclaim";
import AllocatedPayment from "./AllocatedPayment";
import PaymentExceptionNotTheEra from "./paymentExpection_notTheERA";

//The data for tabs working on this page.
const Tabs = [{
  tabId: 1,
  tabName: "Patient Invoices - Claim",
  enable: 1
},
{
  tabId: 2,
  tabName: "Patient Invoices - Cash",
  enable: 1
},
{
  tabId: 3,
  tabName: "Inventory",
  enable: 1
},
{
  tabId: 4,
  tabName: "Practise Remmitance",
  enable: 1
},
{
  tabId: 5,
  tabName: "Allocated Payments",
  enable: 1
},
{
  tabId: 6,
  tabName: "Exceptions-Not on Era",
  enable: 1
},
{
  tabId: 7,
  tabName: "Exceptions-Not on System",
  enable: 1
},

];

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class InvoiceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
    };
  }

  componentDidMount = async() => {
    window.scrollTo(0, 0);
    document.title = 'Invoices - TechToMedix';
    
  }

   /**
   * This method will be called when tab is changed.
   */
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };


  render() {
    const statementsTabData = Tabs.find(
      (element, index) => {
        return element.tabId == this.state.activeTab;
      }
    );
    return (
      <div className={`inventory-audit ${style.invoiceListMainWrapper}`}>
        <div className="row">
          <div className="col-lg-12">
            <h3>Invoice List</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 intro-text">
            <p>
            A list of all the Invoices generated on the system are maintained here. 
            The View action button opens up the Invoice for viewing. 
            The Edit button opens up the Invoice for any changes that may be needed.
            </p>
          </div>
        </div>
        <div className={`row ${style.reportsTabWrapper}`}>
                <div className="col-md-12">
                  <Nav tabs>
                    {Tabs && 
                    Tabs.map(
                      (element, index) => {
                        if(element.enable === 1){
                         return (<NavItem key={`${index + 1}`}>
                            <NavLink
                              className={{
                                active: this.state.activeTab === `${index + 1}`,
                              }}
                              onClick={() => {
                                this.toggle(`${index + 1}`);
                              }}
                            >
                              {element.tabName}
                            </NavLink>
                        </NavItem>)
                      }
                    }
                    )}
                  </Nav>
                  <TabContent
                    activeTab={this.state.activeTab}
                    className={style.tabContentWrapper}
                  >
                  {Tabs[0].enable === 1 &&
                    (<TabPane
                    tabId={`1`}
                    key={`1`}
                          className={style.auditTrailTabContent}
                        >
                        {this.state.activeTab == 1 &&(
                        
                        <PatientInvoiceMediclaim {...this.props} />
                        )} 
                      </TabPane>)}
                      <TabPane
                        tabId={`2`}
                        key={`2`}
                        className={style.auditTrailTabContent}
                      >
                        {this.state.activeTab == 2 &&(
                        <PatientInvoiceCash />
                        )}
                      </TabPane>
                      {Tabs[2].enable === 1 &&
                      (<TabPane
                        tabId={`3`}
                        key={`3`}
                        className={style.auditTrailTabContent}
                      >
                        {this.state.activeTab == 3 &&(
                        
                        <InventoryInvoice /> 
                        )}
                      </TabPane>
                      )}
                       {Tabs[3].enable === 1 &&
                      (<TabPane
                        tabId={`4`}
                        key={`4`}
                        className={style.auditTrailTabContent}
                      >
                         {this.state.activeTab == 4 &&(
                        
                        <PatientInvoiceMediclaim {...this.props} />
                        )} 
                      </TabPane>
                      )}
                        {Tabs[4].enable === 1 &&
                      (<TabPane
                        tabId={`5`}
                        key={`5`}
                        className={style.auditTrailTabContent}
                      >
                         {this.state.activeTab == 5 &&(
                        
                        <AllocatedPayment {...this.props} />
                        )} 
                      </TabPane>
                      )}
                        {Tabs[5].enable === 1 &&
                      (<TabPane
                        tabId={`6`}
                        key={`6`}
                        className={style.auditTrailTabContent}
                      >
                         {this.state.activeTab == 6 &&(
                        
                        <PaymentExceptionNotTheEra {...this.props} />
                        )} 
                      </TabPane>
                      )}
                         {Tabs[6].enable === 1 &&
                      (<TabPane
                        tabId={`7`}
                        key={`7`}
                        className={style.auditTrailTabContent}
                      >
                         {this.state.activeTab == 7 &&(
                        
                        <PaymentExceptionNotTheEra {...this.props} />
                        )} 
                      </TabPane>
                      )}
                  </TabContent>
                </div>
              </div>
         </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    invoiceListData: state.invoiceList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoiceList: (searchKey, sortBy, page) =>
      dispatch(fetchInvoiceList(searchKey, sortBy, page)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList);
